module.exports = __webpack_public_path__ + "img/image22.d0cf660c.webp";